<template>
  <div>
    <div class="section-card" style="background: linear-gradient(135deg, #fff6fa, #ffffff)">
      <h4 class="section-card__title">סקירה אחרונה לפני שליחה</h4>
      <p class="muted" style="margin: 6px 0 0; font-size: 13.5px">
        לאחר השליחה, הצוות שלנו עובר על הלינקטון ומאשר לפרסום. בדרך כלל זה לוקח עד יום עסקים. אפשר להמשיך לערוך את הלינקטון גם בזמן ההמתנה.
      </p>
    </div>

    <div class="review-block" style="background: #fff">
      <div class="review-block__head" style="margin-bottom: 4px">
        <h4 class="review-block__title">{{ form.name || 'ללא שם' }}</h4>
        <span class="badge badge--ready"><span class="dot"></span>{{ typeMeta.name }}</span>
      </div>
      <div class="muted" style="font-size: 13px">
        {{ form.tracks.length }} רצועות · {{ form.youtube ? 'עם קליפ' : 'ללא קליפ' }}
      </div>
    </div>

    <div
      v-if="balance > 0"
      class="review-block"
      style="background: var(--c-success-50); border-color: #c6ebd2"
    >
      <div style="display: flex; align-items: center; gap: 10px; color: var(--c-success-700)">
        <LtIcon name="wallet" :size="20" />
        <div>
          <div style="font-weight: 700">השליחה תנצל לינקטון אחד מהיתרה שלך</div>
          <div style="font-size: 13px; opacity: 0.85">
            נותרו לך {{ balance }} לינקטון{{ balance === 1 ? '' : 'ים' }} מסוג {{ typeMeta.name }} — לא נדרש תשלום נוסף.
          </div>
        </div>
      </div>
    </div>

    <div
      v-else
      class="review-block"
      style="background: #fffbeb; border-color: #fde68a; padding: 20px 24px"
    >
      <div style="display: flex; align-items: flex-start; gap: 14px">
        <LtIcon name="alert" :size="22" style="color: #d97706; flex-shrink: 0; margin-top: 2px" />
        <div style="flex: 1">
          <div style="font-weight: 700; font-size: 15px; color: #92400e; margin-bottom: 4px">
            אין יתרה זמינה מסוג {{ typeMeta.name }}
          </div>
          <div style="font-size: 13.5px; color: #78350f; line-height: 1.6; margin-bottom: 14px">
            כדי לשלוח לינקטון לאישור יש לרכוש יתרה מתאימה. לאחר הרכישה תוכל לחזור ולשלוח.
          </div>
          <button type="button" class="btn btn--primary btn--sm" @click="$emit('go-buy')">
            <LtIcon name="plus" :size="14" /> רכישת לינקטונים
          </button>
        </div>
      </div>
    </div>

    <div class="terms-card" :class="{ 'is-disabled': balance <= 0 }">
      <span
        class="checkbox"
        :class="{ 'is-checked': form.agreed }"
        style="cursor: pointer"
        @click="onCheckboxClick"
      ></span>
      <span>
        אני מאשר/ת את <a href="#" @click.prevent.stop="openTerms">תנאי השימוש</a> ומצהיר/ה שיש לי זכויות שימוש בכל החומרים שהעליתי — תמונות, אודיו, וידאו וטקסטים.
      </span>
    </div>

    <div v-if="showTermsModal" class="modal-overlay" @click.self="showTermsModal = false">
      <div class="modal modal--terms" role="dialog" aria-modal="true">
        <div class="modal__head">
          <h2 class="modal__title">תנאי שימוש</h2>
          <button type="button" class="modal__close" aria-label="סגירה" @click="showTermsModal = false">
            <LtIcon name="close" :size="18" />
          </button>
        </div>
        <div ref="termsBody" class="modal__body terms-body" @scroll="checkScroll">
          <h4 class="terms-body__title">הצהרת הלקוח ותנאי שירות:</h4>
          <ol class="terms-list">
            <li>כי אני הבעלים הבלעדי של כל הזכויות ביצירה, בהתאם להוראות חוק זכויות יוצרים.</li>
            <li>כי אני הבעלים של החומרים הגרפיים שהועברו לחברת לינקטון בע"מ.</li>
            <li>כי אציג את האישורים ו/או הרישיונות שפורטו לעיל באופן מיידי באם אדרש.</li>
            <li>כי ידוע לי כי במידה ולא כך הדבר אהיה חשוף לתביעות משפטיות.</li>
            <li>שיפוי מלא ללינקטון בגין כל תביעה הקשורה להפרת זכויות יוצרים.</li>
            <li>נשיאה בכל הוצאות ההגנה המשפטיות הכרוכות בתביעה.</li>
            <li>דמי ביטול בסך 50% במידה וההזמנה תבוטל לאחר תחילת העבודה.</li>
            <li>הצעת המחיר תקפה ל-14 יום מתאריך הוצאתה.</li>
            <li>על אחריות הלקוח לאשר את הלינקטון לפני הפצתו לתקשורת.</li>
          </ol>
        </div>
        <div v-if="!form.agreed" class="modal__foot">
          <button
            type="button"
            class="btn btn--primary"
            :disabled="!scrolledToBottom"
            @click="acceptTerms"
          >
            <LtIcon name="check" :size="16" /> אני מאשר/ת
          </button>
          <span v-if="!scrolledToBottom" class="terms-scroll-hint">יש לגלול לתחתית כדי לאשר</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LtIcon from '../LtIcon.vue';
import { wizardFormInject } from '../wizardInject.js';

export default {
  name: 'StepTerms',
  mixins: [wizardFormInject],
  components: { LtIcon },
  props: {
    typeMeta: { type: Object, required: true },
    balance: { type: Number, default: 0 },
  },
  emits: ['update:agreed', 'go-buy'],
  data() {
    return {
      showTermsModal: false,
      scrolledToBottom: false,
    };
  },
  methods: {
    onCheckboxClick() {
      if (this.balance <= 0) return;
      if (this.form.agreed) {
        this.$emit('update:agreed', false);
        return;
      }
      this.showTermsModal = true;
      this.scrolledToBottom = false;
      this.$nextTick(() => {
        this.checkScroll();
      });
    },
    openTerms() {
      if (this.balance <= 0) return;
      this.showTermsModal = true;
      this.scrolledToBottom = false;
      this.$nextTick(() => {
        this.checkScroll();
      });
    },
    checkScroll() {
      const el = this.$refs.termsBody;
      if (!el) return;
      this.scrolledToBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 10;
    },
    acceptTerms() {
      this.showTermsModal = false;
      this.$emit('update:agreed', true);
    },
  },
};
</script>

<style lang="scss" scoped>
.modal--terms {
  max-width: 560px;
  width: 90vw;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
}

.terms-body {
  overflow-y: auto;
  max-height: 50vh;
  padding: 24px 28px;
  font-size: 14px;
  line-height: 1.8;
  color: var(--c-ink-700);
}

.terms-body__title {
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 16px;
  color: var(--c-ink-900);
}

.terms-list {
  margin: 0;
  padding: 0 20px;
  list-style: decimal;

  li {
    margin-bottom: 10px;
  }
}

.modal__foot {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 28px;
  border-top: 1px solid var(--c-ink-100);
}

.terms-scroll-hint {
  font-size: 12.5px;
  color: var(--c-ink-400);
  font-style: italic;
}
</style>
